import { GridOptions } from 'ag-grid-community';
import locale from '../../locale/es_Es';

export const defaultGridOptions: GridOptions = {
  localeText: locale.agGrid,
};
